import i18n from 'i18next'
import { initReactI18next, Translation } from 'react-i18next'

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: {
                    'Wallet': 'Wallet',
                    'Deposit': 'Deposit',
                    'Withdrawal': 'Withdrawal',
                    "Send": "Send",
                    "Receive": "Receive",
                    'Toman': 'Toman',
                    'English': 'English',
                    'Persian': 'Persian',
                    'Settings': 'Settings',
                    'Deline': 'Deline',
                    'Signin': 'Signin',
                    'Deline, cooming son ...': 'Deline, cooming son ...',
                    'Language': 'Language',
                    'Night mode': 'Night mode',
                    'Selecting a language ...': 'Selecting a language ...',
                    'Your phone number': 'Your phone number',
                    'Please entring country code and phone number': 'Please entring country code and phone number',
                    'Country': 'Country',
                    'Selecting country': 'Selecting country',
                    'Next': 'Next',
                    'Light mode': 'Light mode',
                    'Rules': 'Rules',
                    'Devs': 'Devs',
                    'Enter the verification code sent to your phone': 'Enter the verification code sent to your phone',
                    'The code entered is invalid': 'The code entered is invalid',
                    'Signout': 'Signout',
                    'Do you want to signout of your account?': 'Do you want to signout of your account?',
                    'Cancel': 'Cancel',
                    'Sessions': 'Sessions',
                    'Notifications': 'Notifications',
                    'Create new note': 'Create new note',
                    'Title': 'Title',
                    'Password': 'Password',
                    'Note': 'Note',
                    'Create': 'Create',
                    'Signin to note': 'Signin to note',
                    'The password is invalid': 'The password is invalid',
                    'Save': 'Save',
                    'Secure Note': 'Secure Note',

                    // titles 
                    'Hiket, home': 'Hiket, Home',
                    'Hiket, rules': 'Hiket, Rules',
                    'Hiket, lnaguages': 'Hiket, Lnaguages',
                    'Hiket, Sessions': 'Hiket, Sessions',
                    'Hiket, Signin': 'Hiket, Signin',
                    'Hiket, Signin verify': 'Hiket, Signin verify',
                    'Hiket, Signin verify': 'Hiket, Signin verify',
                    'Hiket, Transaction': 'Hiket, Transaction',
                    'Hiket, Deline': 'Hiket, Deline',
                    'Hiket, Settings': 'Hiket, Settings',
                    'Hiket, Toman deposit history': 'Hiket, Toman deposit history',
                    'Hiket, Toman history': 'Hiket, Toman history',
                    'Hiket, Toman receive history': 'Hiket, receive history',
                    'Hiket, Toman send history': 'Hiket, send history',
                    'Hiket, Toman withdrawal history': 'Hiket, withdrawal history',

                    'Signin to hiket': 'Signin to hiket',
                    'Username': 'Username',
                    'Theme': 'Theme',
                    'Password recovery': 'Password recovery',
                    'Signup': 'Signup',
                    'Signup to hiket': 'Signup to hiket',
                    'Fullname': 'Fullname',
                    'Enter your phone number for password recovery': 'Enter your phone number for password recovery',
                    'Phone number': 'Phone number',
                    'This username is not available': 'This username is not available',
                    'This password is invalid': 'This password is invalid',
                    'Home': 'Home',
                    'Admin panel': 'Admin panel',

                    'History': 'History',
                    'to': 'to',
                    'Complete': 'Complete',

                    'Name': 'Name',

                    Continue: "Continue",
                    ContinueTRX: "Continue (fee 2 TRX)",
                    ContinueGRAM: "Continue (fee 0.2 GRAM)",

                }
            },
            fa: {
                translation: {
                    "Wallet": "کیف پول",
                    "Deposit": "واریز",
                    "Withdrawal": "برداشت",
                    "Send": "ارسال",
                    "Receive": "دریافت",
                    'Toman': 'تومان',
                    'English': 'انگلیسی',
                    'Persian': 'فارسی',
                    'Settings': 'تنظیمات',
                    'Deline': 'دلاین',
                    'Signin': 'ورود',
                    'Deline, cooming son ...': 'دلاین، به زودی ...',
                    'Language': 'زبان',
                    'Night mode': 'حالت شب',
                    'Selecting a language ...': 'یک زبان انتخاب کنید ...',
                    'Your phone number': 'شماره موبایل شما',
                    'Please entring country code and phone number': 'لطفا کشور و شماره موبایل خود را وارد کنید',
                    'Country': 'کشور',
                    'Selecting country': 'یک کشور انتخاب کنید',
                    'Next': 'بعدی',
                    'Light mode': 'حالت روز',
                    'Rules': 'قوانین',
                    'Devs': 'دِوس',
                    'Enter the verification code sent to your phone': 'کد تایید ارسال شده به موبایل خود را وارد کنید',
                    'The code entered is invalid': 'کد وارد شده نامعتبر است',
                    'Signout': 'خروج از حساب کاربری',
                    'Do you want to signout of your account?': 'ایا میخواهد از حساب کاربری خود خارج شوید؟',
                    'Cancel': 'لغو',
                    'Sessions': 'نشست ها',
                    'Notifications': 'اعلان ها',
                    'Create new note': 'ایجاد یادداشت جدید',
                    'Title': 'عنوان',
                    'Password': 'رمزعبور',
                    'Note': 'یادداشت',
                    'Create': 'ایجاد',
                    'Signin to note': 'ورود به یادداشت',
                    'The password is invalid': 'رمرعبور نامعتبر است',
                    'Save': 'ذخیره',
                    'Secure Note': 'یادداشت امن',

                    // titles
                    "Hiket, home": "هایکت، خانه",
                    "Hiket, rules": "هایکت، قوانین",
                    "Hiket, lnaguages": "هایکت، زبان‌ها",
                    "Hiket, Sessions": "هایکت، نشست‌ها",
                    "Hiket, Signin": "هایکت، ورود",
                    "Hiket, Signin verify": "هایکت، تأیید ورود",
                    "Hiket, Transaction": "هایکت، تراکنش",
                    "Hiket, Deline": "هایکت، دلاین",
                    "Hiket, Settings": "هایکت، تنظیمات",
                    "Hiket, Toman deposit history": "هایکت، تاریخچه واریز تومان",
                    "Hiket, Toman history": "هایکت، تاریخچه تومان",
                    "Hiket, Toman receive history": "هایکت، تاریخچه دریافت تومان",
                    "Hiket, Toman send history": "هایکت، تاریخچه ارسال تومان",
                    "Hiket, Toman withdrawal history": "هایکت، تاریخچه برداشت تومان",

                    'Signin to hiket': 'ورود به هایکت',
                    'Username': 'نام کاربری',
                    'Theme': 'تم',
                    'Password recovery': 'بازیابی رمزعبور',
                    'Signup': 'ثبت نام',
                    'Signup to hiket': 'ثبت نام در هایکت',
                    'Fullname': 'نام کامل',
                    'Enter your phone number for password recovery': 'برای بازیابی رمزعبور شماره موبایل خود را وارد کنید',
                    'Phone number': 'شماره موبایل',
                    'This username is not available': 'این نام کاربری موجود نیست',
                    'This password is invalid': 'این رمزعبور نامعتبر است',
                    'Home': 'خانه',
                    'Admin panel': 'پنل ادمین',

                    'History': 'تاریخچه',

                    'to': 'به',
                    'Completed': 'تکمیل',
                    'Waiting': 'در انتظار',
                    'Rejected': 'رد شده',
                    'R ': 'د ',
                    'S ': 'ا ',
                    'fee ': 'کارمزد ',
                    'Date': 'تاریخ',
                    'Status': 'وضعیت',
                    'Bank Card': 'شماره حساب',
                    'fee': 'کارمزد',
                    'Transaction': 'تراکنش',
                    ' Sended ': ' ارسال شده ',
                    ' Received ': ' دریافت شده ',
                    'Recipient Address': 'آدرس گیرنده',
                    'Transaction Link': 'لینک تراکنش',
                    'memo': 'یادداشت',
                    'Swap': 'تبدیل',
                    'Notifs': 'اعلان ها',
                    'TRX': 'ترون',
                    'USDT': 'تتر',

                    'Authentication': 'احراز هویت',
                    'Edit profile': 'ویرایش پروفایل',
                    'Bitcoin': 'بیت کوین',
                    'Tron': 'ترون',
                    'Tether': 'تتر',
                    'Ethereum': 'اتریوم',
                    'BNB Smart Chain': 'بی ان بی اسمارت چین',
                    'Ton': 'تون',
                    'Solona': 'سولونا',
                    'XRP': 'ریپل',
                    'Dogecoin': 'دوج کوین',
                    'Shiba': 'شیبا',
                    'Gram': 'گرام',

                    'Signin to view your history': 'برای مشاهده تاریخچه وارد شوید',

                    'Complate your authentication': 'احراز هویت خود را تکمیل کنید',
                    'Confirm your email': 'ایمیل خود را تایید کنید',

                    'Upload image': 'آپلود تصویر',

                    'Confirm your email': 'تأیید آدرس ایمیل',
                    'Enter New Email': 'آدرس ایمیل جدید',
                    'Continue': 'ادامه',
                    'This email is invalid': 'آدرس ایمیل وارد شده معتبر نیست',
                    'Enter your new email address. We send a verification code to this email.': 'آدرس ایمیل جدید خود را وارد کنید. برای تأیید، یک کد تأیید به این ایمیل ارسال می‌شود.',

                    'Verify your email': 'تأیید آدرس ایمیل',
                    'Confirm': 'تأیید',
                    'This Code is invalid': 'کد تأیید وارد شده معتبر نیست',

                    "emailVerificationDescription": "یک کد تأیید ۶ رقمی به {{email}} ارسال شده است. برای ادامه، کد را در کادر زیر وارد کنید.",

                    'Wrong email?': 'ایمیل اشتباه است؟',
                    'Change email': 'تغییر ایمیل',

                    "verify older email": "تأیید ایمیل فعلی",

                    "You already have a registered email address: {{email}}; to change it, you must first verify your access to the current email.":
                        "شما از قبل یک ایمیل ثبت‌شده دارید: {{email}}. برای تغییر آن، ابتدا باید دسترسی خود را به ایمیل فعلی تأیید کنید.",

                    "Verify Email": "تأیید ایمیل",

                    'Amount': 'مبلغ',
                    'Deposit receipt': 'شماره پیگیری',
                    'Deposit date': 'تاریخ واریز', 
                    'T': 'تومان',


                    'Name': 'نام',
                    'Price': 'قیمت',
                    'Caption': 'توضیحات',
                    'Images': 'عکس ها',
                    'email | username': 'ایمیل | نام کاربری',
                    'Code': 'کد',
                    'Create a new password': 'ساخت رمز جدید',
                    'New password': 'رمز جدید',
                    'Signin to view this section': 'برای دیدن این بخش وارد شوید',


                    'Profile': 'پروفایل',
                    'Products': 'محصولات',
                    'Product': 'محصول',
                    'My Products': 'محصولات من',
                    'Add Product': 'افزودن محصول',
                    'No products yet.': 'هنوز محصولی وجود ندارد.',
                    'Loading...': 'در حال بارگذاری...',
                    'All Products': 'همه محصولات',
                    'With Image': 'دارای عکس',
                    'Without Image': 'بدون عکس', 
                    'Newest': 'جدیدترین',
                    'Oldest': 'قدیمی‌ترین',
                    'Price: Low to High': 'قیمت: از کم به زیاد',
                    'Price: High to Low': 'قیمت: از زیاد به کم',
                    'No Image': 'بدون عکس',
                    'Digital Product': 'محصول دیجیتال',
                    'You dont have any bank card': 'شما هیچ کارت بانکی‌ای ندارید.',
                    'Add Bank Card': 'افزودن کارت بانکی',
                    
                    'Card Holder Name': 'نام دارند کارت',
                    'Sheba Number': 'شماره شبا',
                    'Card Number': 'شماره کارت',
                    'Save Card': 'ذخیره کارت',
                    'Saving...': 'ذخیره سازی...',
                    'Select Card': 'انتخاب کارت',
                    'Select Network': 'انتخاب شبکه',
                    "Send ": "ارسال ",
                    "Memo": "ممو",
                    "Address": "آدرس",
                    Continue: "ادامه",
                    ContinueTRX: "ادامه (کارمزد 2 TRX)",
                    ContinueGRAM: "ادامه (کارمزد 0.2 GRAM)",
                    'Interal accounting': 'حسابداری داخلی',
                    'Licenses': 'مجوز ها',
                    'Value in Dollars': 'ارزش به دلار',

                    'Total Deposits': 'مجموع واریز ها',
                    'Total Value of Deposits': 'ارزش مجموع واریز ها',
                    'Total Withdrawals': 'مجموع برداشت ها',
                    'Total Value of Withdrawals': 'ارزش مجموع برداشت ها',
                    'Total Completed Withdrawals': 'مجموع برداشت های تکمیل شده',
                    'Total Value of Completed Withdrawals': 'ارزش مجموع برداشت های تکمیل شده',
                    'Submit': 'ثبت',
                    'Order': 'سفارش',
                    'Discription': 'توضیحات',
                    'Sender': 'ارسال کننده',
                    'Receiver': 'دریافت کننده',
                    'Shopping Cart': 'سبد خرید',
                    'Empty': 'خالی',
                    'Deposits': 'واریزها',
                    'Withdrawals': 'برداشتها',
                    'Purchases': 'خریدها',
                    'Sales': 'فروشها',
                    'Wallet Statistics': 'آمار کیف پول',
                    'Store Statistics': 'آمار فروشگاه',
                    'Trade Statistics': 'آمار تجارت',
                    'Total Products': 'مجموع محصولات',
                    'Total Available Products': 'مجموع محصولات موجود',
                    'Total Unavailable Products': 'مجموع محصولات ناموجود',
                    'Total Price of Available Products': 'مجموع قیمت محصولات موجود',
                    'Total Value of Available Products': 'مجموع ارزش محصولات موجود',
                    'Total of Product Sales': 'مجموع محصولات فروش رفته',
                    'Total Price of Products Sales': 'مجموع قیمت محصولات فروش رفته',
                    'Total Value of Products Sales': 'مجموع ارزش محصولات فروش رفته',
                    'Total of Completed Products Sales': 'مجموع محصولات فروش تکمیل شده',
                    'Total Price of Completed Products Sales': 'مجموع قیمت محصولات فروش تکمیل شده',
                    'Total Value of Completed Products Sales': 'مجموع ارزش محصولات فروش تکمیل شده',
                    'Total of Products Purchases': 'مجموع محصولات خرید شده',
                    'Total Price of Products Purchases': 'مجموع قیمت محصولات خرید شده',
                    'Total Value of Products Purchases': 'مجموع ارزش محصولات خرید شده',
                    'Total of Completed Products Purchases': 'مجموع محصولات خرید تکمیل شده',
                    'Total Price of Completed Products Purchases': 'مجموع قیمت محصولات خرید تکمیل شده',
                    'Total Value of Completed Products Purchases': 'مجموع ارزش محصولات خرید تکمیل شده',
                    'Search': 'جستجو',
                    'Statistics': 'آمار',

                    'Receipts': 'دریافت ها',
                    'Unconfirmed Receipts': 'دریافت های تایید نشده',
                    'Bank Accounts': 'حساب های بانکی',
                    'Add': 'اضافه کردن',

                    'Card Number 2': 'شماره شبا' ,
                    'add Bank Accounts': 'اضافه کردن حساب بانکی',
                } 
            },


        },

        lng: 'en',
        fallbackLng: 'en',
        interpolation: { escapeValue: false }
    });


export default i18n